import React, { useEffect, useState } from 'react';
import { useLanguageContext } from '@/hooks/context-hooks';
import Button from '../../../Common/button/Button';

const PortfolioAssigneeContactDetails = ({ assigneeData, onChange }) => {
  const { language } = useLanguageContext();
  const [showAssigneeContact, setShowAssigneeContact] = useState(false);
  const [assigneeContactDetails, setAssigneeContactDetails] = useState({
    Assignee_Name: '',
    Assignee_Designation: '',
    Assignee_Phone_Number: '',
    Assignee_Email_ID: '',
    Assignee_Working_Hours: '',
  });

  useEffect(() => {
    if (assigneeData) {
      setAssigneeContactDetails({
        Assignee_Name: assigneeData.Assignee_Name || '',
        Assignee_Designation: assigneeData.Assignee_Designation || '',
        Assignee_Phone_Number: assigneeData.Assignee_Phone_Number || '',
        Assignee_Email_ID: assigneeData.Assignee_Email_ID || '',
        Assignee_Working_Hours: assigneeData.Assignee_Working_Hours || '',
      });
      // Automatically open if assignee details are already filled
      if (
        assigneeData.Assignee_Name ||
        assigneeData.Assignee_Designation ||
        assigneeData.Assignee_Phone_Number ||
        assigneeData.Assignee_Email_ID ||
        assigneeData.Assignee_Working_Hours
      ) {
        setShowAssigneeContact(true);
      }
    }
  }, [assigneeData]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;
    const updatedState = {
      ...assigneeContactDetails,
      [name]: val,
    };
    setAssigneeContactDetails(updatedState);
    onChange(updatedState);
  };

  return (
    <section className="container my-4 px-0">
      <Button
        type="button"
        className="ps-0 outline-none fs-6 fw-semibold text-primary d-flex align-items-center gap-2 border-0 bg-transparent mb-3"
        onClick={() => setShowAssigneeContact(!showAssigneeContact)}
      >
        <span>Assign Contact Details (optional)</span>
        {showAssigneeContact ? (
          <i className="bi bi-chevron-up" />
        ) : (
          <i className="bi bi-chevron-down" />
        )}
      </Button>

      {showAssigneeContact && (
        <div 
          className="p-4 rounded-4 shadow-sm" 
          style={{ 
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0' 
          }}
        >
          <p className="text-muted mb-4" style={{ fontSize: '0.88rem' }}>
            Provide contact details for the person managing this portfolio.
          </p>
          <div className="row g-4">
            {/* Name */}
            <div className="col-md-6">
              <label htmlFor="Assignee_Name" className="form-label fw-semibold text-secondary mb-2" style={{ fontSize: '0.9rem' }}>
                Name
              </label>
              <input
                type="text"
                className="form-control premium-form-control"
                id="Assignee_Name"
                name="Assignee_Name"
                value={assigneeContactDetails.Assignee_Name}
                placeholder="Enter Name"
                onChange={handleInputChange}
              />
            </div>

            {/* Designation */}
            <div className="col-md-6">
              <label htmlFor="Assignee_Designation" className="form-label fw-semibold text-secondary mb-2" style={{ fontSize: '0.9rem' }}>
                Designation
              </label>
              <input
                type="text"
                className="form-control premium-form-control"
                id="Assignee_Designation"
                name="Assignee_Designation"
                value={assigneeContactDetails.Assignee_Designation}
                placeholder="e.g. Sales Manager, Support Representative"
                onChange={handleInputChange}
              />
            </div>

            {/* Phone Number */}
            <div className="col-md-6">
              <label htmlFor="Assignee_Phone_Number" className="form-label fw-semibold text-secondary mb-2" style={{ fontSize: '0.9rem' }}>
                Phone Number
              </label>
              <input
                type="tel"
                className="form-control premium-form-control"
                maxLength="10"
                id="Assignee_Phone_Number"
                name="Assignee_Phone_Number"
                value={assigneeContactDetails.Assignee_Phone_Number}
                placeholder="Enter 10-digit Phone Number"
                onChange={handleInputChange}
              />
            </div>

            {/* Email ID */}
            <div className="col-md-6">
              <label htmlFor="Assignee_Email_ID" className="form-label fw-semibold text-secondary mb-2" style={{ fontSize: '0.9rem' }}>
                Email ID
              </label>
              <input
                type="email"
                className="form-control premium-form-control"
                id="Assignee_Email_ID"
                name="Assignee_Email_ID"
                value={assigneeContactDetails.Assignee_Email_ID}
                placeholder="Enter Email Address"
                onChange={handleInputChange}
              />
            </div>

            {/* Working Hours */}
            <div className="col-md-6">
              <label htmlFor="Assignee_Working_Hours" className="form-label fw-semibold text-secondary mb-2" style={{ fontSize: '0.9rem' }}>
                Working Hours
              </label>
              <input
                type="text"
                className="form-control premium-form-control"
                id="Assignee_Working_Hours"
                name="Assignee_Working_Hours"
                value={assigneeContactDetails.Assignee_Working_Hours}
                placeholder="e.g. 9:00 AM - 6:00 PM, Mon-Sat"
                onChange={handleInputChange}
              />
            </div>


          </div>
        </div>
      )}
    </section>
  );
};

export default PortfolioAssigneeContactDetails;
